<script lang="ts" setup>
import { provide } from 'vue';
import { useFormStore } from '../model/FormStore';
import { FORM_ITEM_INJECTION_KEY } from '../types/constants';
import type { IFormItemProps } from '../types/FormItem';

const props = defineProps<IFormItemProps>();

const formStore = useFormStore();
const field = formStore!.registerField();
provide(FORM_ITEM_INJECTION_KEY, `${field.id}`);
</script>

<template>
  <div data-slot="form-item" :class="{ 'no-errors': noErrors }" class="form-item">
    <slot />
  </div>
</template>

<style scope>
.form-item {
  display: flex;
  flex-direction: column;
  width: fit-content;
  margin-bottom: 20px;
}
.form-item:not(.no-errors):has(> label[data-error='true']) {
  margin-bottom: 2px;
}

.form-item > label[data-slot='form-label']:not(:empty) {
  margin-bottom: 4px;
}

/* .form-item > div[data-slot='form-description'] {
  margin-top: 4px;
} */

.form-item.no-errors > div[data-slot='form-message'] {
  display: none;
}
</style>
